import { render } from "./OurProducts.vue?vue&type=template&id=0a29d9d9&scoped=true"
import script from "./OurProducts.vue?vue&type=script&lang=js"
export * from "./OurProducts.vue?vue&type=script&lang=js"

import "./OurProducts.vue?vue&type=style&index=0&id=0a29d9d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a29d9d9"]])

export default __exports__